import { useContext } from 'react'

const useCustomContext = (customContext, hookName) => {
  const context = useContext(customContext)
  if (context === undefined) {
    throw new Error(`${hookName} must be used within a ${customContext.displayName}`)
  }
  return context
}

export default useCustomContext
